import { createContext, useContext, useState } from 'react';

const HostTaskSubmission = createContext();

const initialState = {};

const HostTaskSubmissionProvider = ({ children }) => {
  const [state, setState] = useState(initialState);

  const updateState = (payload) => setState((prev) => ({ ...prev, ...payload }));
  const resetState = () => setState(initialState);

  return <HostTaskSubmission.Provider value={{ updateState, resetState, state }}>{children}</HostTaskSubmission.Provider>;
};

export const useHostTaskSubmissionState = () => {
  return useContext(HostTaskSubmission);
};

export default HostTaskSubmissionProvider;
